import React from 'react';
import { Link } from 'react-router-dom';
import theme from './theme';

// Material Symbol component using Google Fonts
const MaterialSymbol = ({ name, size = 18 }) => (
  <span
    className="material-symbols-outlined"
    style={{ fontSize: size, lineHeight: 1 }}
  >
    {name}
  </span>
);

export const SidebarLinks = ({ links, pathname }) => {
  return (
    <ul className="sidebar-nav">
      {links.map((link) => {
        const isActive = pathname === link.url || pathname.startsWith(link.url + '/');
        return (
          <span key={link.id}>
            <li className={`sidebar-nav-item${isActive ? ' active' : ''}`}>
              <Link
                to={link.url}
                className="sidebar-nav-link"
                style={
                  isActive
                    ? theme.sidebarActiveLink
                    : theme.sidebarLink
                }
              >
                <div className="sidebar-nav-cont">
                  <div className="sidebar-nav-icon">
                    <MaterialSymbol name={link.icon} size={20} />
                  </div>

                  <div className="sidebar-nav-text">
                    {link.titleComponent ? (
                      <div className="sidebar-nav-title">
                        {link.titleComponent}
                        {link.badge && (
                          <span className="sidebar-nav-badge">{link.badge}</span>
                        )}
                      </div>
                    ) : (
                      <div className="sidebar-nav-title">
                        {link.title}
                        {link.badge && (
                          <span className="sidebar-nav-badge">{link.badge}</span>
                        )}
                      </div>
                    )}
                    {link.subtitle && (
                      <div className="sidebar-nav-subtitle">{link.subtitle}</div>
                    )}
                  </div>
                </div>
              </Link>
            </li>
            {link.links && <SidebarLinks links={link.links} pathname={pathname} />}
          </span>
        );
      })}
    </ul>
  );
};

export const SidebarSection = ({ title, shortTitle, links, pathname }) => (
  <div className="sidebar-section">
    <div className="sidebar-section-title">
      <span className="sidebar-section-title-full">{title}</span>
      {shortTitle && (
        <span className="sidebar-section-title-short">{shortTitle}</span>
      )}
    </div>
    <SidebarLinks links={links} pathname={pathname} />
  </div>
);
